import { getWithAuthentication, postWithAuthentication, deleteWithAuthentication } from './http'

export const bookingByProperty = async (propertyId) =>
  getWithAuthentication(`${process.env.REACT_APP_BOOKING_API}?property_id=${propertyId}`).then((res) => res.data)

export const bookingByLegacyBooking = async (bookingLegacyId) =>
  getWithAuthentication(`${process.env.REACT_APP_BOOKING_API}?booking_legacy_id=${bookingLegacyId}`)
    .then((res) => res.data[0])
    .catch((e) => e)

export const bookingById = async (id) =>
  getWithAuthentication(`${process.env.REACT_APP_BOOKING_API}/${id}`).then((res) => res.data)

export const getBookingAttachmentByType = async (id, type) =>
  getWithAuthentication(`${process.env.REACT_APP_API_GW_BOOKING_API}/bookings/${id}/booking-attachments/${type}`).then(
    (res) => res.data,
  )

export const deleteBookingAttachment = async (id) =>
  deleteWithAuthentication(`${process.env.REACT_APP_API_GW_BOOKING_API}/booking-attachments/${id}`).then((res) => res.data)

export const getBookingAttachmentDownloadLink = async (id, attachment_id) =>
  postWithAuthentication(`${process.env.REACT_APP_API_GW_BOOKING_API}/bookings/${id}/booking-attachments/${attachment_id}/url`)
